import type { IStudio } from "../screens/Dashboard/SubComponents/Studio/interfaces/Studio.interface";
import type { IBounds } from "../screens/Dashboard/SubComponents/Studio/interfaces/sub-interfaces/Bounds.interface";
import type {
  EStudioWidgetType,
  IStudioWidget,
} from "../screens/Dashboard/SubComponents/Studio/interfaces/sub-interfaces/Widgets.interface";

export type SceneTemplateKind = "starting_soon" | "brb" | "ending" | "sources";

/**
 * Recipe shape on the wire — `id`/`label` are added by the client at
 * apply-time so multiple applies don't collide on uuid.
 */
export type SceneWidgetRecipeWire = {
  [W in IStudioWidget as W["type"]]: {
    type: W["type"];
    bounds: IBounds;
    active: boolean;
    options: W["options"];
  };
}[EStudioWidgetType];

export interface SceneTemplateResponse {
  id: string;
  slug: string;
  title: string;
  imageUrl?: string;
  kind: SceneTemplateKind;
  designAspectRatio: string;
  /** Full IStudio payload — replaces the active studio when applied. */
  studio: IStudio;
  /** Widget recipes the client materialises onto IStudio.widgets[] at apply. */
  widgetRecipes: SceneWidgetRecipeWire[];
  /**
   * Clasificación: familia/gama (cyberpunk, aurora, anime-vhs…) + tipo de
   * layout (single-cam, multicam, reaction, watch-party, camera-first, graphic)
   * + orientación (horizontal/vertical). El picker agrupa por familia.
   * Opcional por compatibilidad con backends previos a la columna `tags`.
   */
  tags?: string[];
  createdAt: string;
  updatedAt: string;
}

export interface SceneTemplateListQuery {
  kind?: SceneTemplateKind;
  designAspectRatio?: string;
}

export class SceneTemplateServiceUnavailableError extends Error {
  readonly status: number;
  constructor(status: number, message?: string) {
    super(message ?? "Scene template catalog is not available yet.");
    this.name = "SceneTemplateServiceUnavailableError";
    this.status = status;
  }
}
